import base64 from 'base-64'
import Cookies from 'js-cookie'
import { encodeBase64 } from '../app/share/constant'

export const TOKEN = 'token'
export const EXPIRES_ON = 'expires_on'
export const EXPIRES_DATE = 'expires_date'
export const USER_ID = 'user_id'
export const FULL_NAME = "fullname"
export const ROLE = "role"
export const EMAIL = "email"
export const O365_TOKEN = "o365_token"
export const USER_IMAGE = "user_image"
export const IS_NPI_ADMIN = "is_npi_admin"
export const IS_ADMIN = "is_admin"
export const SYSTEM_INFO = "system_info"
export const IS_ADMIN_TRACKER = "is_admin_tracker"
export const IS_ADMIN_TRAINING = "is_admin_training"
export const IS_ADMIN_CAR_RESERVATION = "is_admin_car_reservation"
export const EMP_ID = "emp_id"
export const IS_ACCESS_MY_TRACKER = "is_access_my_tracker"
export const IS_ACCESS_MY_TRAINING = "is_access_my_tracker"
export const IS_ACCESS_MY_CAR_RESERVATION = "is_access_my_car_reservation"
export const IS_DRIVER = "is_driver"
export const MODULES = "modules"
export const COST_CENTER_NAME = "cost_center_name"
export const MODULE_NAME = "module_name"
export const URL_INCOMING = "url_incoming"

function getCookie(key) {
    try {
        const value = Cookies.get(key)
        let setValue = ''

        if (value && typeof value === 'string') {
            setValue = base64.decode(value)
        }

        return setValue
    } catch (error) {
        return null
    }

}

function setCookie(key, value, expires) {
    const valueToString = String(value)
    let setValue = ''
    if (typeof valueToString === 'string') {
        setValue = base64.encode(valueToString)
    }
    if (expires && typeof expires === "number" && expires > 0) {
        Cookies.set(key, setValue, { expires: expires })
    } else {
        Cookies.set(key, setValue)
    }

}

function removeCookie(key) {
    Cookies.remove(key)
}

export function authentication(dataAuth, isRemember) {
    console.log("authentication", dataAuth)
    const { user: { email, fullName, id, isNpiAdmin, isAdmin, isAdminTrainingCourse, isAdminTracker, empId, costCenterName, isDriver, isAdminCarReserve }
        , token, expiresDate, expiresOn, modules } = dataAuth
    clearToken()
    setCookie(FULL_NAME, fullName)
    setCookie(EMAIL, email)
    setCookie(USER_ID, id)
    setCookie(EMP_ID, empId)
    setCookie(TOKEN, token)
    setCookie(EXPIRES_DATE, expiresDate)
    setCookie(EXPIRES_ON, expiresOn)
    setCookie(IS_NPI_ADMIN, isNpiAdmin)
    setCookie(IS_ADMIN, isAdmin)
    setCookie(IS_ADMIN_TRACKER, isAdminTracker)
    setCookie(IS_ADMIN_TRAINING, isAdminTrainingCourse)
    setCookie(IS_ADMIN_CAR_RESERVATION, isAdminCarReserve)
    setCookie(MODULES, modules)
    setCookie(COST_CENTER_NAME, costCenterName ? encodeBase64(costCenterName) : "")
    setCookie(IS_DRIVER, isDriver)
}
export function setO365TokenCookie(data) {
    setCookie(O365_TOKEN, data)
}
export function getO365Token() {
    return getCookie(O365_TOKEN)
}
export function setUserImageCookie(data) {
    setCookie(USER_IMAGE, data)
}
export function getUserImageCookie() {
    return getCookie(USER_IMAGE)
}
export function clearToken() {
    removeCookie(TOKEN)
    removeCookie(EXPIRES_DATE)
    removeCookie(USER_ID)
    removeCookie(EMP_ID)
    removeCookie(FULL_NAME)
    removeCookie(EMAIL)
    removeCookie(IS_ADMIN)
    removeCookie(IS_NPI_ADMIN)
    removeCookie(IS_ADMIN_TRACKER)
    removeCookie(IS_ADMIN_TRAINING)
    removeCookie(IS_ADMIN_CAR_RESERVATION)
    removeCookie(MODULES)
    removeCookie(COST_CENTER_NAME)
    removeCookie(IS_DRIVER)
    removeCookie(URL_INCOMING)
}
export function getAllCookies() {
    return {
        [TOKEN]: getCookie(TOKEN),
        [EXPIRES_ON]: getCookie(EXPIRES_ON),
        [EXPIRES_DATE]: getCookie(EXPIRES_DATE),
        [USER_ID]: getCookie(USER_ID),
        [IS_NPI_ADMIN]: getCookie(IS_NPI_ADMIN),
        [IS_ADMIN]: getCookie(IS_ADMIN),
        [IS_ADMIN_TRAINING]: getCookie(IS_ADMIN_TRAINING),
        [IS_ADMIN_CAR_RESERVATION]: getCookie(IS_ADMIN_CAR_RESERVATION),
        [IS_DRIVER]: getCookie(IS_DRIVER),
        [COST_CENTER_NAME]: getCookie(COST_CENTER_NAME),
        [EMP_ID]: getCookie(EMP_ID),
        [MODULES]: getCookie(MODULES),
        [FULL_NAME]:getCookie(FULL_NAME),
        [EMAIL]:getCookie(EMAIL)

    }
}
export function getModules() {
    return getCookie(MODULES)
}
export function getToken() {
    return getCookie(TOKEN)
}
export function getUserId() {
    return getCookie(USER_ID)
}
export function getFullName() {
    return getCookie(FULL_NAME)
}
export function getCostCenterName() {
    return getCookie(COST_CENTER_NAME)
}
export function getEmail() {
    return getCookie(EMAIL)
}
export function getRole() {
    return getCookie(ROLE)
}
export function getExpireDate() {
    return getCookie(EXPIRES_DATE)
}
export function getIsNpiAdmin() {
    return getCookie(IS_NPI_ADMIN)
}
export function getIsAdminTraining() {
    return getCookie(IS_ADMIN_TRAINING)
}
export function getIsAdminCarReservation() {
    return getCookie(IS_ADMIN_CAR_RESERVATION)
}
export function getIsAdmin() {
    return getCookie(IS_ADMIN)
}
export function getIsDriver() {
    return getCookie(IS_DRIVER)
}

export function getIsAccessMyTracker() {
    return getCookie(IS_ACCESS_MY_TRACKER)
}

export function getIsAccessMyTraining() {
    return getCookie(IS_ACCESS_MY_TRAINING)
}

export function getIsAccessMyCarReservation() {
    return getCookie(IS_ACCESS_MY_CAR_RESERVATION)
}

export function getIsAccessAdminTracker() {
    return getCookie(IS_ADMIN_TRACKER)
}
export function setSystemInfo(data) {
    // setCookie(SYSTEM_INFO, data)
    Cookies.set(SYSTEM_INFO, data)
}
export function getSystemInfo() {
    return getCookie(SYSTEM_INFO)
}

export function setModule(name) {
    Cookies.set(MODULE_NAME, name)
}
export function getModule() {
    return getCookie(MODULE_NAME)
}

export function setUrlIncoming(data) {
    setCookie(URL_INCOMING, data)
}
export function getUrlIncoming() {
    return getCookie(URL_INCOMING)
}


// WEBPACK FOOTER //
// ./src/lib/auth.js